
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M17 4.99999C17.83 4.99999 18.5 4.32999 18.5 3.49999C18.5 2.83999 17.84 1.85999 17.39 1.27999C17.19 1.01999 16.8 1.01999 16.6 1.27999C16.16 1.85999 15.5 2.83999 15.5 3.49999C15.5 4.32999 16.17 4.99999 17 4.99999ZM12 4.99999C12.83 4.99999 13.5 4.32999 13.5 3.49999C13.5 2.83999 12.84 1.85999 12.39 1.27999C12.19 1.01999 11.8 1.01999 11.6 1.27999C11.16 1.85999 10.5 2.83999 10.5 3.49999C10.5 4.32999 11.17 4.99999 12 4.99999ZM7 4.99999C7.83 4.99999 8.5 4.32999 8.5 3.49999C8.5 2.83999 7.84 1.85999 7.39 1.27999C7.19 1.01999 6.8 1.01999 6.6 1.27999C6.16 1.85999 5.5 2.83999 5.5 3.49999C5.5 4.32999 6.17 4.99999 7 4.99999ZM18.92 8.00999C18.72 7.41999 18.16 6.99999 17.5 6.99999H6.5C5.84 6.99999 5.29 7.41999 5.08 8.00999L3.11 13.68C3.04 13.89 3 14.11 3 14.34V21.5C3 22.33 3.67 23 4.5 23C5.33 23 6 22.33 6 21.5V21H18V21.5C18 22.32 18.67 23 19.5 23C20.32 23 21 22.33 21 21.5V14.34C21 14.12 20.96 13.89 20.89 13.68L18.92 8.00999ZM6.5 18C5.67 18 5 17.33 5 16.5C5 15.67 5.67 15 6.5 15C7.33 15 8 15.67 8 16.5C8 17.33 7.33 18 6.5 18ZM17.5 18C16.67 18 16 17.33 16 16.5C16 15.67 16.67 15 17.5 15C18.33 15 19 15.67 19 16.5C19 17.33 18.33 18 17.5 18ZM5 13L6.27 9.17999C6.41 8.77999 6.79 8.49999 7.22 8.49999H16.78C17.21 8.49999 17.59 8.77999 17.73 9.17999L19 13H5Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-local-car-wash`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconLocalCarWash

    ```js
    <b-new-b-icon-local-car-wash />
    ```
</docs>


